import { useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const readIds = (value) => [...new Set((value || '').split(',').map(Number).filter((id) => Number.isSafeInteger(id) && id > 0))];

export function readCatalogQuery(params) {
  const value = Number(params.get('page'));
  return {
    query: (params.get('q') || '').slice(0, 160),
    kinds: readIds(params.get('kind')),
    manufacturers: readIds(params.get('maker')),
    page: Number.isSafeInteger(value) && value > 0 ? value : 1,
    sort: params.get('sort') === 'DESC' ? 'DESC' : 'ASC',
  };
}

export default function useCatalogQuery() {
  const [params, setParams] = useSearchParams();
  const state = useMemo(() => readCatalogQuery(params), [params]);
  const [input, setInput] = useState(state.query);
  const timer = useRef();
  useEffect(() => {
    setInput(state.query);
    return () => clearTimeout(timer.current);
  }, [state.query]);
  useEffect(() => () => clearTimeout(timer.current), []);

  const update = (changes, replace = false) => {
    clearTimeout(timer.current);
    setParams((current) => {
      const next = new URLSearchParams(current);
      for (const [key, value] of Object.entries(changes)) {
        if (value === '' || value === null) next.delete(key);
        else next.set(key, String(value));
      }
      return next;
    }, { replace });
  };
  return {
    ...state, input, params,
    update,
    changeSearch: (value) => {
      setInput(value);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => update({ q: value.trim(), page: null }, true), 300);
    },
    clear: () => {
      clearTimeout(timer.current);
      setInput('');
      setParams({});
    },
  };
}
